import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../sections/Hero";
import About from "../sections/About";
import Partners from "../sections/Partners";
import Frameworks from "../sections/Frameworks";
import Innovation from "../sections/Innovation";
import Activities from "../sections/Activities";
import TrainingTopics from "../sections/TrainingTopics";
import Achievements from "../sections/Achievements";
import Susi from "../sections/Susi";
import Books from "../sections/Books";
import Gallery from "../sections/Gallery";
import Testimonials from "../sections/Testimonials";
import Events from "../sections/Events";
import Blog from "../sections/Blog";
import Contact from "../sections/Contact";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <About />
        <Partners />
        <Frameworks />
        <Innovation />
        <Activities />
        <TrainingTopics />
        <Achievements />
        <Susi />
        <Books />
        <Gallery />
        <Testimonials />
        <Events />
        <Blog />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
